"use client";

import React, { useState } from "react";
import { useI18n } from "@/i18n/client";
import { useSessionContext } from "@/lib/auth/SessionContextProvider";
import * as Accordion from "@radix-ui/react-accordion";
import AdditionalInformation from "./AdditionalInformation/AdditionalInformation";
import AfterSales from "./AfterSales/AfterSales";
import Documentation from "./Documentation/Documentation";
import Overview from "./Overview/Overview";
import Specification from "./Specification/Specification";
import styles from "./ProductPageAccordian.module.scss";
import { useProductContext } from "@/providers/ProductContextProvider";

interface ProductPageAccordianProps {
	builderContent: any;
	isNotPurchasable?: boolean;
}

const ProductPageAccordian: React.FC<ProductPageAccordianProps> = ({
	builderContent,
	isNotPurchasable = true,
}) => {
	const t = useI18n();
	const { session } = useSessionContext();
	const AccordianContent = [
		"Overview",
		"Specification",
		"Documentation",
		"AdditionalInformation",
		// "AfterSales",
	];
	const [handleValue, setHandleValue] = useState(AccordianContent);
	const { product } = useProductContext();
	const customFieldSpecification = product.customFields?.filter((field) =>
		field.name.startsWith("S|"),
	);
	const hasCustomFieldSpecifications =
		customFieldSpecification !== undefined &&
		customFieldSpecification.length > 0;

	const accordions = [
		{
			name: "overview",
			title: t("product.overview"),
			content: <Overview isInAccordion={true} />,
			canShow: !isNotPurchasable,
		},
		{
			name: "specification",
			title: t("product.specification.specification"),
			content: <Specification isInAccordion={true} />,
			canShow: !isNotPurchasable && hasCustomFieldSpecifications,
		},
		{
			name: "documentation",
			title: t("product.documentation"),
			content: <Documentation />,
			canShow: session,
		},
		{
			name: "additionalInformation",
			title: t("product.additionalInformation"),
			content: <AdditionalInformation />,
			canShow: true,
		},
		// {
		// 	name: "afterSalesSupport",
		// 	title: t("product.afterSalesSupport"),
		// 	content: <AfterSales content={builderContent.afterSalesSupport} />,
		// 	canShow: true,
		// },
	];
	console.debug("🚀 ~ accordions:", accordions);

	return (
		<section>
			<Accordion.Root
				type='multiple'
				defaultValue={accordions.map((accordion) => accordion.name)}
				value={handleValue}
				onValueChange={setHandleValue}
				className={styles.root}
			>
				{accordions.map(
					(accordion, index) =>
						accordion.canShow && (
							<div key={index} id={accordion.name}>
								{accordion.content}
							</div>
						),
				)}
			</Accordion.Root>
		</section>
	);
};

export default ProductPageAccordian;
